import { Link } from "react-router-dom";
import Footer from "./Footer";

const Home = () => {
    return (
        <>
            <div className="HomeContainer">
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-md-7 text-center mt-5 mb-5">
                            <img className="imagenlogo" src="./image/Logos/Arbolitos2025_ok.png" />
                            <h5 className="tituloHome">PON TU <strong className="strongHome">ÁRBOL</strong>, CELEBRA ESTA <strong className="strongHome">NAVIDAD</strong> CON NOSOTROS Y <strong className="strongHome">GANA GRANDES ALEGRÍAS.</strong></h5>
                            {/* <Link className="btn botonResgistro text-uppercase" to="/Registro">REGÍSTRATE</Link> */}
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default Home;
